import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import CtaSidebar from './CtaSidebar';

import data from '../data/dataEN.json';

class Services extends Component {
  state = {
    services: data.services,
    cta: data.cta.sidebar,
  };

  render() {
    return (
      <div>
        <div className="business-banner">
          <div className="hvrbox">
            <img
              src={this.state.services.info.bgImg}
              alt={this.state.services.info.title}
              className="hvrbox-layer_bottom"
            />
            <div className="hvrbox-layer_top">
              <div className="container">
                <div className="overlay-text text-left">
                  <h3>{this.state.services.info.heading}</h3>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <a href={this.state.services.info.url}>{this.state.services.info.heading}</a>
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="padding-top-large" /> */}

        <div className="bussiness-about-company blog-list-layout">
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <div className="padding-top-middle" />
                {this.state.services.core_services.map(service => (
                  <div className="service-box">
                    <div className="blog-content">
                      <a href={`/services-en/${service.slug}`}>{service.title}</a>
                      <p>{service.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="col-md-3">
                {/* <div className="padding-top-large" /> */}
                <div className="about-company-right">
                  <div className="padding-top-middle" />

                  <div className="right-menubar">
                    <h3>Services</h3>
                    <ul>
                      {this.state.services.core_services.map(subnav => (
                        <li>
                          <NavLink to={`/services-en/${subnav.slug}`} activeClassName="active">
                            {subnav.title}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="padding-top-middle" />
                  <CtaSidebar cta={this.state.cta} />
                  <div className="padding-top-middle" />
                </div>
              </div>

              <div className="padding-top-middle" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Services;



// WEBPACK FOOTER //
// ./src/components/Services.js